import { SET_USER, SET_ERRORS, LOADING_USER } from "../types";
import api from "../../services/api";
import JwtDecode from "jwt-decode";

export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_USER });
  console.log("Obtendo token salvo do localStorage");
  const token = sessionStorage.PhpontoIdToken;
  const tokenDecote = JwtDecode(token);
  console.log("tokenDecote", tokenDecote.data[0]);
  dispatch({
    type: SET_USER,
    payload: tokenDecote.data[0],
  });
  // api.get('/usuario/perfil')
  //   .then(res => {
  //     dispatch({
  //       type: SET_USER,
  //       payload: res.data
  //     })
  //   })
  //   .catch(err => {
  //     console.error(err);
  //     dispatch({
  //       type: SET_ERRORS,
  //       payload: err.response.data
  //     })
  //   })
};
